import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { NoResultsImage } from './Assets/Images'

type Props = {
	/**
	 * The search term to echo back, when there was one.
	 *
	 * Optional because half the call sites are not searches at all — "you have
	 * no invoices", "you have no courses" — and they were rendering
	 * `<NoResults />` against a required prop. React printed nothing for the
	 * missing value, so the only visible symptom was a trailing space after the
	 * heading, but the contract said those uses were invalid.
	 */
	querySearchKey?: string
}
const NoResults: React.FC<Props> = ({ querySearchKey }) => {
	const [t] = useTranslation('search')
	const history = useNavigate()
	return (
		<NoResultsWrapper>
			<img alt="no results" src={NoResultsImage} />
			<NoResultsBody>
				<NoResultsTitle>
					{querySearchKey ? `${t('no_results_found')} ${querySearchKey}` : t('no_results_found')}
				</NoResultsTitle>
				<NoResultsFallback>
					<Trans i18nKey="combined" ns="search" components={{ strong: <ExploreLink onClick={() => history('/')} /> }} />
				</NoResultsFallback>
			</NoResultsBody>
		</NoResultsWrapper>
	)
}

export default NoResults

const NoResultsWrapper = styled.div`
	/* min-height: 85vh; */
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 26px;
`
const NoResultsBody = styled.div`
	display: grid;
`
const NoResultsTitle = styled.label`
	color: ${props => props.theme.colors.princetonOrange};
	margin-bottom: 1rem;
	font-size: 1rem;
`
const NoResultsFallback = styled.label`
	font-size: 1rem;
`
const ExploreLink = styled.a`
	text-decoration: underline;
	cursor: pointer;
	color: ${props => props.theme.colors.maxBluePurple};
`
